import { render, staticRenderFns } from "./DaKaGenJin.vue?vue&type=template&id=cea4c80e&"
import script from "./DaKaGenJin.vue?vue&type=script&lang=js&"
export * from "./DaKaGenJin.vue?vue&type=script&lang=js&"
import style0 from "./DaKaGenJin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cea4c80e')) {
      api.createRecord('cea4c80e', component.options)
    } else {
      api.reload('cea4c80e', component.options)
    }
    module.hot.accept("./DaKaGenJin.vue?vue&type=template&id=cea4c80e&", function () {
      api.rerender('cea4c80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/DaKaGenJin.vue"
export default component.exports